import axios from 'axios'

export const getProducts = async (productsData) => {
  const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/modularContents/richRelevance/products`

  return await axios.post(endpoint, { products: productsData })
}
